import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled, {withTheme} from 'styled-components';
import TextToHtml from '../TextToHtml';

const TitleComponent = styled.div`
  display: flex;
  flex-direction: ${props => props.theme?.progressBar?.useProgressSteps ? 'column' : 'row'};
  justify-content: space-between;
  align-items: ${props => props.theme?.progressBar?.useProgressSteps ? 'stretch' : 'center'};
  ${props => props.theme.title.multiLine
    ? `min-height: ${props.theme.title.height};`
    : `height: ${props.theme.title.height};`
  }
  color: ${props => props.theme.title.color};
  background-color: ${props => props.theme.title.backgroundColor};
  ${props => (props.theme?.progressBar?.useProgressTabs || props.theme?.progressBar?.useProgressSteps) ? '' : 'padding: 0 17px 0 17px;'}
  line-height: ${props => props.theme.title.height};
  border-top-left-radius: ${props => props.theme.title.borderRadius};
  border-top-right-radius: ${props => props.theme.title.borderRadius};

  h2 {
    ${props => props.theme.title.widthProperty || 'width: 220px;'}
    ${props => props.theme.title.multiLine
      ? `line-height: 1.8rem;`
      : `text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;`
    }
    font-family: ${props => props.theme.title.fontFamily};
    font-size: ${props => props.theme.title.fontSize};
    font-weight: ${props => props.theme.title.fontWeight};
    border-top-left-radius: ${props => props.theme.title.borderRadius};
    color: ${props => props.theme.title.color};
  }

  ${props => props.theme.title?.stickyOnMobile && `
    @media (max-width: 480px) {
      position: sticky;
      top: ${props.theme.title.stickyTop || '0'};
      z-index: ${props.theme.title.stickyZIndex || 2};
    }
  `}
`;

const StepsTitle = styled.div`
  box-sizing: border-box;
  padding: 16px;
  font-family: ${props => props.theme.title.fontFamily};
  font-size: ${props => props.theme.title.fontSize};
  font-weight: ${props => props.theme.title.fontWeight};
  color: ${props => props.theme.title.color};
  line-height: ${props => props.theme.title.lineHeight};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoComponent = styled.div`
  cursor: pointer;
  width: ${props => props.theme.logo.width};
  height: ${props => props.theme.logo.height};
  background-image: url(${props => props.theme.logo.backgroundImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;

  ${props => props.theme.title?.logoMobileOnly && `
    @media (min-width: 481px) {
      display: none;
    }
  `}

  @media (max-width: 480px) {
    width: ${props => props.theme.logo.widthMobile};
    height: ${props => props.theme.logo.heightMobile};
  }
`;

TitleComponent.defaultProps = {
  theme: {
    title: {
      fontFamily: '"Maax Bold", "Arial", "sans-serif"',
      fontSize: '26px',
      height: '65px',
      fontWeight: 'normal',
      borderRadius: '0',
      backgroundColor: '#000',
      color: '#fff'
    }
  }
};

class Title extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    theme: PropTypes.object.isRequired,
    children: PropTypes.element
  };

  render () {
    const useSteps = this.props.theme?.progressBar?.useProgressSteps;
    return (
      <TitleComponent>
        {useSteps
          ? <StepsTitle>{this.props.showLogo && <LogoComponent />}<TextToHtml text={this.props.title} /></StepsTitle>
          : (!this.props.theme?.title?.showInBody && <h2>{this.props.title}</h2>)}
        {this.props.children}
      </TitleComponent>
    );
  }
}

export default withTheme(Title);
